<div *ngIf="dialog.type === 'response'" class="dialog-container">
  <div class="sparkles-container">
    <div *ngIf="isLastItem" class="sparkles-frame"></div>
    <f-icon
      *ngIf="isLastItem"
      icon-config='{"iconName": "sparkles", "iconType": "solid"}'
    ></f-icon>
  </div>
  <div
    [ngClass]="dialog.type + '-type dialog'"
  >
    <!-- Use markdown component for rich content -->
    <markdown 
      *ngIf="hasMarkdownFormatting(dialog.value)" 
      [data]="dialog.value">
    </markdown>
    <!-- Fallback to simple HTML conversion for plain text -->
    <div 
      *ngIf="!hasMarkdownFormatting(dialog.value)"
      [innerHTML]="dialog.value | utils : ['promptToHtml']">
    </div>
  </div>
</div>
<div *ngIf="dialog.type === 'dashboards'" class="dialog-container">
  <div class="sparkles-container">
    <div *ngIf="isLastItem" class="sparkles-frame"></div>
    <f-icon
      *ngIf="isLastItem"
      icon-config='{"iconName": "sparkles", "iconType": "solid"}'
    ></f-icon>
  </div>
  <div class="dashboards-container">
  <ng-container *ngFor="let dashboard of dialog.dashboards">
    <f-button
      [text]="dashboard.title"
      variant="action"
      (buttonClicked)="onDashboardButtonClicked(dashboard)"
    ></f-button>
  </ng-container>
  </div>
</div>
<div *ngIf="dialog.type === 'buttons'" class="buttons-container">
  <div class="sparkles-container">
    <div *ngIf="isLastItem" class="sparkles-frame"></div>
    <f-icon
      *ngIf="isLastItem"
      icon-config='{"iconName": "sparkles", "iconType": "solid"}'
    ></f-icon>
  </div>
  <ng-container *ngFor="let button of dialog.buttons">
    <f-button
      [text]="button"
      size="small"
      variant="action"
      (buttonClicked)="onButtonClicked(button)"
    ></f-button>
  </ng-container>
</div>
<div *ngIf="dialog.type === 'list'" class="list-container">
  <ul *ngFor="let item of dialog.listItems" class="list-items">
    <li [innerHTML]="item"></li>
  </ul>
</div>
<div *ngIf="dialog.type === 'prompt'" class="response-container">
  <div
    [ngClass]="dialog.type + '-type dialog'"
  >
    <!-- Use markdown component for rich content -->
    <markdown 
      *ngIf="hasMarkdownFormatting(dialog.value)" 
      [data]="dialog.value">
    </markdown>
    <!-- Fallback to simple HTML conversion for plain text -->
    <div 
      *ngIf="!hasMarkdownFormatting(dialog.value)"
      [innerHTML]="dialog.value | utils : ['promptToHtml']">
    </div>
  </div>
  <!-- <div *ngIf="isLoading" class="response-type dialog">
    <div class="sparkles-container">
      <div class="sparkles-frame pulsating"></div>
      <f-icon
        icon-config='{"iconName": "sparkles", "iconType": "solid"}'
      ></f-icon>
    </div>
  </div> -->
</div>
<div *ngIf="dialog.type === 'embeddedLink'" class="response-container">
  <f-link
    text="{{ dialog.value.dashboardName }}"
    (linkClicked)="onContentTitleClicked(dialog)"
  />
</div>
<div
  *ngIf="dialog.type === 'loading' && !errorWithWebSocket"
  class="dialog-container"
>
  <div class="sparkles-container">
    <div *ngIf="!errorResponseReceived" class="sparkles-frame pulsating"></div>
    <f-icon
      *ngIf="!errorResponseReceived"
      icon-config='{"iconName": "sparkles", "iconType": "solid"}'
    ></f-icon>
  </div>
  <div
    *ngIf="!errorResponseReceived && hasExcessiveDelay"
    class="loading-type dialog"
  >
    <div class="message-container" style="position: relative;">
      <div class="wait-message-1">
        <span class="loading-message fade-in-text animation-delay-0">This might</span>
        <span class="loading-message fade-in-text animation-delay-1">&nbsp;take a moment</span>
        <span class="loading-message fade-in-text animation-delay-2">.</span>
        <span class="loading-message fade-in-text animation-delay-3">.</span>
        <span class="loading-message fade-in-text animation-delay-4">.</span>
      </div>
      <div #waitMessage2 class="wait-message-2">
        <span class="loading-message animation-delay-0">Finalizing</span>
        <span class="loading-message animation-delay-1">&nbsp;details</span>
        <span class="loading-message animation-delay-2">.</span>
        <span class="loading-message animation-delay-3">.</span>
        <span class="loading-message animation-delay-4">.</span>
      </div>
    </div>
  </div>
</div>
